








































































































import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import { Constants } from '@/constants/constants';
import { GEnum } from '@/constants/enum.defination';
import { BreadCrumbElement } from '@/models/bread-crumb-element';
import GCustomBreadCrumb from '@/components/GCustomBreadCrumb.vue';
import GTitleBar from '@/components/GTitleBar.vue';
import { activityModule } from '@/store/modules/entities/activity.module';
import { Activity } from '@/models/activity/activity';
import { eventModule } from '@/store/modules/entities/event.module';
import { Event } from '@/models/jgrow/event';
import { EventForList } from '@/models/jgrow/event-for-list';
import { EventGiftCcourse } from '@/models/jgrow/event';
import { Survey } from '@/models/jgrow/survey';
import GLoading from '@/components/GLoading.vue';
import GOptionalIcon from '@/components/GOptionalIcon.vue';

@Component({
  name: 'GJgrowEvent',
  components: {
    GLoading,
    GTitleBar,
    GCustomBreadCrumb,
    GOptionalIcon,
  },
  computed: {},
  methods: {},
  validations: {},
})
export default class GJgrowEvent extends mixins(GPageBase) {
  breadCrumbItems: BreadCrumbElement[] = [];
  listColumn: object[] = [];
  lazy: boolean = false;
  processing: boolean = false;
  size: number = 24;

  async mounted() {
    await activityModule.fetchActivities();
    await eventModule.fetchEvents();

    this.breadCrumbItems = [
      {
        title: this.$t('HOME').toString(),
        icon: 'ios-home',
        routerPath: '/pages/home',
      },
      { title: 'イベント' },
    ];
    this.createColumn();
    this.lazy = true;
  }

  get isProcessing(): boolean {
    return this.processing;
  }

  get events() {
    return eventModule.events.sort((a: Event, b: Event) => {
      return a.startDate < b.startDate ? 1 : -1;
    });
  }

  get eventForList() {
    return eventModule.eventForList.sort((a: EventForList, b: EventForList) => {
      return a.eventStartDate < b.eventStartDate ? 1 : -1;
    });
  }

  beforeSurveyStartDate(data: Event): Date {
    const beforeSuv = data.surveys.find((suv: Survey) => suv.type == 1);
    return beforeSuv ? beforeSuv.startDate : undefined;
  }

  beforeSurveyEndDate(data: Event): Date {
    const beforeSuv = data.surveys.find((suv: Survey) => suv.type == 1);
    return beforeSuv ? beforeSuv.endDate : undefined;
  }

  afterSurveyStartDate(data: Event): Date {
    const beforeSuv = data.surveys.find((suv: Survey) => suv.type == 2);
    return beforeSuv ? beforeSuv.startDate : undefined;
  }

  afterSurveyEndDate(data: Event): Date {
    const beforeSuv = data.surveys.find((suv: Survey) => suv.type == 2);
    return beforeSuv ? beforeSuv.endDate : undefined;
  }

  hasBeforeExam(data: Event): string {
    const beforeExam = data.giftCourses.find((egc: EventGiftCcourse) => egc.type == 1);
    return beforeExam ? 'あり' : 'なし';
  }

  hasAfterExam(data: Event): string {
    const afterExam = data.giftCourses.find((egc: EventGiftCcourse) => egc.type == 2);
    return afterExam ? 'あり' : 'なし';
  }

  handleEdit(data: EventForList) {
    this.$router.push(`/pages/jgrow/event/create?mode=${GEnum.JgrowEventPageMode.Edit}&eventID=${data.ID}`);
  }

  handleProgress(data: EventForList) {
    this.$router.push(`/pages/jgrow/event/${data.ID}`);
  }

  handleAnalyze(data: EventForList) {
    this.$router.push(`/pages/jgrow/analysis?eventID=${data.ID}`);
  }

  rowDisableColor(row: Activity): string {
    if (row.companyID === null) {
      return 'invalid-row';
    }
    return 'no-setting-row';
  }

  handleDeleteConfirm(row: Event) {
    let config = {
      title: `${row.eventName}を削除しますか？`,
      onOk: () => {
        this.loadingPage(
          () => {
            eventModule.deleteEvent(row.ID).then(() => {});
          },
          () => {
            window.location.reload();
          },
          3000
        );
      },
      onCancel: () => {
        return;
      },
    };
    this.$Modal.confirm(config);
  }

  // 編集可否
  // JTB作成のものは編集不可（作成した CompanyID が null）
  isDisabled(row: Activity) {
    return !(row.companyID === null);
  }

  createColumn(): void {
    this.listColumn = [this.columnEventName, this.columnBeforeSurvey, this.columnEventTerm, this.columnAfterSurvey, this.columnBeforeExam, this.columnAfterExam, this.columnEventActions];
  }

  get columnEventName(): any {
    return {
      title: 'イベント名',
      key: 'eventName',
      width: 320,
    };
  }

  get columnBeforeSurvey(): any {
    return {
      title: '事前アンケート期間',
      slot: 'before-survey',
    };
  }

  get columnEventTerm(): any {
    return {
      title: 'イベント期間',
      slot: 'event-term',
    };
  }

  get columnAfterSurvey(): any {
    return {
      title: '事後アンケート期間',
      slot: 'after-survey',
    };
  }

  get columnBeforeExam(): any {
    return {
      title: '事前測定',
      slot: 'before-exam',
      width: 70,
    };
  }

  get columnAfterExam(): any {
    return {
      title: '事後測定',
      slot: 'after-exam',
      width: 70,
    };
  }

  get columnEventActions(): any {
    return {
      title: '操作',
      slot: 'event-actions',
      width: 124,
    };
  }
}
